import { useCallback, useEffect, useState } from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { usePermission } from '../../hooks/usePermission';
import api from '../../lib/api';
import { GhanaCardCheck } from '../../pages/pos/controlled/GhanaCardCheck';
import { PharmacistReview } from '../../pages/pos/controlled/PharmacistReview';

export const PendingControlledRequests = () => {
  const { allowed } = usePermission('rx_approve');
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState(null);
  const load = useCallback(() => api.get('/controlled/requests', { params: { status: 'pending' } }).then(r => setRows(r.data.requests || [])).catch(() => {}), []);
  useEffect(() => {
    if (!allowed) return undefined;
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [allowed, load]);
  const refreshActive = () => api.get(`/controlled/requests/${active.request_id}`).then(r => setActive(r.data));
  if (!allowed || rows.length === 0) return null;
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50/60 dark:bg-amber-950/20 p-3 space-y-2" data-testid="controlled-pending-panel">
      <p className="text-sm font-semibold text-amber-800">Waiting for your approval ({rows.length})</p>
      {rows.map((r) => (
        <div key={r.request_id} className="flex items-center justify-between gap-2 rounded-md bg-background px-3 py-2 text-sm">
          <div className="min-w-0">
            <p className="font-medium truncate">{r.full_name} · {(r.product_names || []).join(', ')}</p>
            <p className="text-xs text-muted-foreground">Requested by {r.requested_by_name || 'staff'} · {new Date(r.created_at).toLocaleTimeString()}</p>
          </div>
          <Badge variant="outline" className={r.identity?.verified ? 'text-emerald-700' : 'text-amber-700'}>{r.identity?.verified ? 'Card verified' : 'Card to verify'}</Badge>
          <Button size="sm" onClick={() => setActive(r)} data-testid={`controlled-review-${r.request_id}`}>Review</Button>
        </div>
      ))}
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="controlled-review-dialog">
          <DialogHeader><DialogTitle>Controlled drug approval</DialogTitle></DialogHeader>
          {active && (
            <div className="space-y-3">
              <GhanaCardCheck patientId={active.patient_id} identity={active.identity} form={active} canApprove onChanged={refreshActive} />
              <PharmacistReview request={active} canApprove onDecided={() => { setActive(null); load(); }} />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
